import { createBrowserRouter, Navigate } from "react-router";

import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { useAuthStore } from "./stores/authStore";

function HomeRedirect() {
  const { user } = useAuthStore();

  if (user) {
    return <Navigate to="/projects" replace />;
  }

  return <Navigate to="/home" replace />;
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeRedirect />,
  },
  {
    path: "/home",
    lazy: () =>
      import("./components/marketing/MarketingPage").then((m) => ({
        Component: m.MarketingPage,
      })),
  },
  {
    path: "/sign-in",
    lazy: () =>
      import("./components/auth/SignInPage").then((m) => ({
        Component: m.SignInPage,
      })),
  },
  {
    path: "/waitlist",
    lazy: () =>
      import("./components/auth/WaitlistPage").then((m) => ({
        Component: m.WaitlistPage,
      })),
  },
  {
    path: "/licenses",
    lazy: () =>
      import("./components/legal/LicensesPage").then((m) => ({
        Component: m.LicensesPage,
      })),
  },
  {
    path: "/account",
    element: <ProtectedRoute />,
    children: [
      {
        lazy: () =>
          import("./components/account/AccountLayout").then((m) => ({
            Component: m.AccountLayout,
          })),
        children: [
          {
            index: true,
            lazy: () =>
              import("./components/account/AccountPage").then((m) => ({
                Component: m.AccountPage,
              })),
          },
        ],
      },
    ],
  },
  {
    path: "/admin",
    element: <ProtectedRoute />,
    children: [
      {
        lazy: () =>
          import("./components/admin/AdminLayout").then((m) => ({
            Component: m.AdminLayout,
          })),
        children: [
          {
            index: true,
            element: <Navigate to="/admin/users" replace />,
          },
          {
            path: "users",
            lazy: () =>
              import("./components/admin/AdminUsersPage").then((m) => ({
                Component: m.AdminUsersPage,
              })),
          },
          {
            path: "waitlist",
            lazy: () =>
              import("./components/admin/AdminWaitlistPage").then((m) => ({
                Component: m.AdminWaitlistPage,
              })),
          },
          {
            path: "promo",
            lazy: () =>
              import("./components/admin/AdminPromoCodesPage").then((m) => ({
                Component: m.AdminPromoCodesPage,
              })),
          },
        ],
      },
    ],
  },
  {
    path: "/projects",
    element: <ProtectedRoute />,
    children: [
      {
        lazy: () =>
          import("./components/layout/RootLayout").then((m) => ({
            Component: m.RootLayout,
          })),
        children: [
          {
            index: true,
            lazy: () =>
              import("./components/landing/LandingPage").then((m) => ({
                Component: m.LandingPage,
              })),
          },
          {
            path: ":id",
            lazy: () =>
              import("./components/project/ProjectView").then((m) => ({
                Component: m.ProjectView,
              })),
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);
